module.exports = __webpack_public_path__ + "static/media/logo.7ae4ed5f.webp";